import { render, staticRenderFns } from "./DataProfileTab.vue?vue&type=template&id=00f05126&scoped=true&"
import script from "./DataProfileTab.vue?vue&type=script&lang=js&"
export * from "./DataProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./Operations.scss?vue&type=style&index=0&id=00f05126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f05126",
  null
  
)

export default component.exports